import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Checkbox,
    CardContent,
    Card,
} from "@mui/material";
import {useParams} from "react-router";
import {defaultVariables} from "../../../../../config";
import {getMediaURL, truncate} from "../../../../../config/values";
import Grid from "@mui/material/Grid2";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import {connect} from "trim-redux";
import {useNavigate} from "react-router-dom";
import Title from "../../../../components/elements/Title";
import AppCardLoaderFields from "../../../../components/loaders/AppCardLoaderFields";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import {Alert} from "@mui/lab";
import {BadgeInfo} from "lucide-react";

const ShopCategories = ({create,user, isApp}) => {
    const [allCategories, setAllCategories] = useState([]);
    const [shopCategories, setShopCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigation = useNavigate();
    const { t } = useTranslation();

    let { id } = useParams();
    if(!id && !create){
        if(!!user.shop){
            id = user.shop.id;
        }else{
            navigation('/')
        }
    }
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    };
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                axios
                    .get(`${defaultVariables.url}/shops/get-categories/${id}`,config)
                    .then(
                        (response) => {
                            setShopCategories(response.data.shop_categories);
                            setAllCategories(response.data.all_categories);
                        }
                    )
                    .catch((error) => console.error(error));


            } catch (error) {
                console.error("Error fetching categories:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
    }, []);

    const toggleCategory = async (categoryId) => {
        try {
            const isSelected = shopCategories.includes(categoryId);
            axios
                .get(`${defaultVariables.url}/shops/toggle-category/${id}/${categoryId}`,config)
                .then(
                    (response) => {
                        setShopCategories((prev) =>
                            isSelected
                                ? prev.filter((id) => id !== categoryId)
                                : [...prev, categoryId]
                        )
                    }
                )
                .catch((error) => console.error(error));
        } catch (error) {
            console.error("Error toggling category:", error);
        }
    };

    return (
        <Grid container spacing={2}>
            {
                !isApp &&
                <>
                    <Grid item size={12}>
                        <Title align="left" color="text" className="panel-title">{t('categories')}</Title>
                    </Grid>
                    <Grid item size={12}>
                        <Alert severity="success"  icon={<BadgeInfo  className="lucide-large"/>}>
                            {t('shopCategoriesDesc')}
                        </Alert>
                    </Grid>
                </>
            }
            {
                loading ?
                    <Grid item size={12}>
                        <AppCardLoaderFields/>
                    </Grid>
                    :
                    <>
                        {allCategories.map((category) => {
                            const isSelected = shopCategories.includes(category.id);
                            return (
                                <Grid item size={{xs:6,sm:6,md:4,lg:3}} key={category.id}>
                                    <Card
                                        className={clsx('categoryChooserCard',isSelected ? "active" : "")}
                                        selected={isSelected}
                                        onClick={() => toggleCategory(category.id)}
                                    >
                                        <img
                                            src={getMediaURL(category.file)}
                                            alt={category.name}

                                        />
                                        <CardContent>
                                            <Typography variant="body1" className="md-text-center">{truncate(category.name , 27)}</Typography>
                                            <div className="cat-selected">
                                                {isSelected && <Checkbox checked={true} />}
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            );
                        })}
                    </>
            }

        </Grid>
    );
};
const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
    isApp: state.isApp,
});


export default withStyles(Styles)(connect(mstp)(ShopCategories));

